import React, { Component } from 'react';
//import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import footerImage from '../../images/common/footer_logo.svg';
import './Footer.css';

class Footer extends Component {
  render() {
    const { t, i18n } = this.props;
    let privacyUrl;
    let termsUrl;
    let eulaUrl;
    let contactUrl;
    if (i18n.language === 'kr') {
      privacyUrl = 'https://www.insignary.com/ko/privacy-statement';
      termsUrl = 'https://www.insignary.com/ko/terms-use';
      eulaUrl = 'https://www.insignary.com/en/eula';
      contactUrl = 'https://www.insignary.com/ko/contact-us';
    } else {
      privacyUrl = 'https://www.insignary.com/en/privacy-statement';
      termsUrl = 'https://www.insignary.com/en/terms-use';
      eulaUrl = 'https://www.insignary.com/en/eula';
      contactUrl = 'https://www.insignary.com/en/contact-us';
    }

    return (
      <div>
        <footer className="footer">
          <div className="footer_box">
            <p className="footer_logo">
              <img src={footerImage} alt="" />
            </p>
            <p className="text" style={{ whiteSpace: 'pre-line' }}>
              {t('footer.message.logo')}
            </p>
          </div>
          <div className="footer_line" />
          <div className="footer_box">
            <div className="footer_menu">
              <a
                href={privacyUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('footer.menu.privacy')}
              </a>
              <span className="bar" />
              <a
                href={termsUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('footer.menu.terms')}
              </a>
              <span className="bar" />
              <a
                href={eulaUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('footer.menu.eula')}
              </a>
              <span className="bar" />
              <a
                href={contactUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('footer.menu.contact')}
              </a>
            </div>
            <div className="copyright">
              {t('footer.message.copyright')}
              {/**state.user.appVersion */}
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
export default withTranslation()(Footer);
